import React from 'react';
import { observer } from 'owa-mobx-react';
import { ToggleFavoriteButton } from 'owa-favorites';
import { getDensityModeCssClass } from 'owa-fabric-theme';
import { isSingleLineListView } from 'owa-mail-layout';
import { getIsSearchTableShown, type TableView } from 'owa-mail-list-store';
import type { UserSettingsStyleSelector } from '../../utils/getStyleSelectorAsPerUserSettings';
import { Tooltip } from '@fluentui/react-components';
import {
    customTextContainer,
    showSelectionModeButtonSCL,
    showSelectionModeButtonMCL,
    full,
    medium,
    compact,
    customHeaderText,
    customHeaderTextWithFavorite,
    customHeaderTextNoMarginBottom,
    favoriteIconFull,
    favoriteIconMedium,
    favoriteIconCompact,
} from './MailListHeaderSecondRow.scss';
import classnames from 'owa-classnames';
import type MailboxInfo from 'owa-client-types/lib/MailboxInfo';

export interface MailListHeaderSecondRowTextContentProps {
    text?: string;
    containerCssClass?: string;
    showFavoriteToggle?: boolean;
    onFavoriteToggleClick?: (evt: React.MouseEvent<unknown>) => void;
    isInFavorites?: boolean;
    styleSelectorAsPerUserSettings?: UserSettingsStyleSelector;
    mailboxInfo: MailboxInfo;
    tableView?: TableView;
    noBottomMargin?: boolean;
}

const noop = () => {};

const defaultExport: React.FunctionComponent<MailListHeaderSecondRowTextContentProps> = observer(
    function MailListHeaderSecondRowTextContent(props: MailListHeaderSecondRowTextContentProps) {
        const isSingleLineView = isSingleLineListView();
        const showSelectionModeButon = !getIsSearchTableShown();
        const shouldShowFavoriteToggle = props.showFavoriteToggle;
        const noBottomMargin = props.noBottomMargin ?? false;

        return (
            <div
                className={classnames(
                    customTextContainer,
                    props.containerCssClass,
                    showSelectionModeButon && !isSingleLineView && showSelectionModeButtonSCL,
                    showSelectionModeButon && isSingleLineView && showSelectionModeButtonMCL,
                    getDensityModeCssClass(full, medium, compact)
                )}
                role="heading"
                aria-level={2}
            >
                {props.text && (
                    <Tooltip content={props.text} relationship="label">
                        <span
                            className={classnames(
                                customHeaderText,
                                shouldShowFavoriteToggle && customHeaderTextWithFavorite,
                                noBottomMargin && customHeaderTextNoMarginBottom,
                                getDensityModeCssClass(full, medium, compact)
                            )}
                        >
                            {props.text}
                        </span>
                    </Tooltip>
                )}
                {shouldShowFavoriteToggle && (
                    <ToggleFavoriteButton
                        isInFavorites={props.isInFavorites ?? false}
                        onClick={props.onFavoriteToggleClick ?? noop}
                        iconStyles={getDensityModeCssClass(
                            favoriteIconFull,
                            favoriteIconMedium,
                            favoriteIconCompact
                        )}
                        mailboxInfo={props.mailboxInfo}
                    />
                )}
            </div>
        );
    },
    'MailListHeaderSecondRowTextContent'
);
export default defaultExport;
